export default {
  // ── fans/page.tsx ──
  'fans.hero.title': 'STIMMEN DER WIRKUNG',
  'fans.hero.subtitle': 'ECHTE MENSCHEN. ECHTE GESCHICHTEN. GLOBALE WIRKUNG.',
  'fans.hero.body': 'Hinter jedem Schlagzeile stehen Menschen, deren Leben von den Botschaften von Andrew und Tristan Tate über Disziplin, Verantwortung, körperliche Stärke, Familie, Glauben, Resilienz und persönliche Entwicklung beeinflusst wurden. Dies sind ihre Worte.',
  'fans.hero.disclaimer': 'Die Erfahrungsberichte spiegeln die persönlichen Meinungen und Erlebnisse ihrer jeweiligen Autoren wider. Tate Protest überprüft nicht jede Aussage oder Behauptung unabhängig.',
  'fans.hero.imgAlt': 'Globale Unterstützer vereint in Solidarität',
  'fans.hero.imgTitle': 'Stimmen der Wirkung – Globale Tate-Unterstützer in Solidarität',

  'fans.seo.title': 'Stimmen der Wirkung | Erfahrungsberichte von Tate-Unterstützern | Tate Protest',
  'fans.seo.description': 'Lies persönliche Geschichten von Menschen, die Andrew und Tristan Tate Einfluss auf ihre Disziplin, Fitness, mentale Widerstandskraft, ihr Berufsleben, ihren Glauben, ihre Familienbeziehungen und ihren Lebenssinn zuschreiben.',
  'fans.seo.keywords': 'Erfahrungsberichte von Tate-Unterstützern, Stimmen der Wirkung, Geschichten von Andrew-Tate-Fans, Tristan-Tate-Einfluss, Tate-Protest-Gemeinschaft, persönliche Entwicklung, Disziplin, Fitness, Glaube',
  'fans.seo.aboutName': 'Erfahrungsberichte von Unterstützern der Tate-Brüder',
  'fans.seo.aboutDescription': 'Eine Sammlung von Berichten aus erster Hand von Personen, die den Einfluss von Andrew und Tristan Tate auf ihr Leben beschreiben.',

  'fans.allTestimonials.label': 'ALLE ERFAHRUNGSBERICHTE',
  'fans.allTestimonials.body': 'Entdecke die vollständige Sammlung von Unterstützergeschichten. Nutze die Filter, um nach Thema zu browsen.',

  // ── CommunityVoicesSection ──
  'fans.community.label': 'GEMEINSCHAFTSSTIMMEN',
  'fans.community.body': 'Eine Auswahl an Stimmen von Unterstützern aus der gesamten Gemeinschaft.',

  // ── FeaturedStories ──
  'fans.featured.label': 'AUSGEWÄHLTE TRANSFORMATIONSGESCHICHTEN',
  'fans.featured.body': 'Ausführliche persönliche Berichte darüber, wie die Botschaft von Andrew und Tristan Tate bedeutende Veränderungen inspiriert hat.',
  'fans.featured.readFull': 'VOLLSTÄNDIGEN BERICHT LESEN',
  'fans.featured.collapse': 'EINKLAPPEN',
  'fans.featured.ariaExpand': 'Vollständigen Bericht lesen',
  'fans.featured.ariaCollapse': 'Bericht einklappen',
  'fans.featured.defaultLabel': 'PERSÖNLICHE GESCHICHTE',

  // ── FilterBar ──
  'fans.filter.all': 'ALLE GESCHICHTEN',
  'fans.filter.discipline': 'DISZIPLIN',
  'fans.filter.mentalHealth': 'PSYCHISCHE GESUNDHEIT',
  'fans.filter.fitness': 'FITNESS',
  'fans.filter.business': 'BUSINESS',
  'fans.filter.family': 'FAMILIE',
  'fans.filter.faith': 'GLAUBE',
  'fans.filter.dueProcess': 'RECHTSSTAATLICHKEIT',

  // ── FinalCTA ──
  'fans.finalCta.title': 'DIE WIRKUNG LÄSST SICH NICHT AUF EINEN SCHLAGZEILE REDUZIEREN',
  'fans.finalCta.body': 'Öffentliche Persönlichkeiten werden oft durch isolierte Clips, Anschuldigungen und Kontroversen beurteilt. Diese Erfahrungsberichte dokumentieren einen anderen Teil der Geschichte: die Menschen, die Andrew und Tristan Tate die Förderung von Disziplin, Verantwortung, Resilienz, Glauben, körperlicher Verbesserung und persönlichem Ehrgeiz zuschreiben.',
  'fans.finalCta.readTateStory': 'DIE TATE-GESCHICHTE LESEN',
  'fans.finalCta.exploreLegal': 'DIE RECHTSFÄLLE ERKUNDEN',
  'fans.finalCta.signPetition': 'PETITION UNTERZEICHNEN',

  // ── GlobalImpact ──
  'fans.globalImpact.title': 'WIRKUNG JENSEITS DER SCHLAGZEILEN',
  'fans.globalImpact.body': 'Die hier vertretenen Personen beschreiben Veränderungen in Disziplin, körperlicher Gesundheit, mentaler Resilienz, Business, Glauben, Familienbeziehungen und einem erneuerten Sinn für Zweck.',
  'fans.globalImpact.discipline': 'DISZIPLIN',
  'fans.globalImpact.mentalResilience': 'MENTALE STÄRKE',
  'fans.globalImpact.fitness': 'FITNESS',
  'fans.globalImpact.business': 'BUSINESS',
  'fans.globalImpact.family': 'FAMILIE',
  'fans.globalImpact.faith': 'GLAUBE',

  // ── LegalDisclaimer ──
  'fans.legal.title': 'RECHTLICHER UND REDAKTIONELLER HINWEIS',
  'fans.legal.p1': 'Die auf dieser Seite veröffentlichten Erfahrungsberichte spiegeln die individuellen Meinungen und berichteten Erlebnisse ihrer jeweiligen Autoren wider. Die Veröffentlichung bedeutet nicht, dass Tate Protest jede Sachaussage unabhängig überprüft hat. Die Berichte werden aus Gründen des öffentlichen Interesses, der Interessenvertretung und zu Informationszwecken präsentiert und stellen keine Rechtszeugenaussagen oder Beweise dar.',
  'fans.legal.p2': 'Die Erfahrungsberichte spiegeln die persönlichen Meinungen und Erlebnisse ihrer jeweiligen Autoren wider. Tate Protest überprüft nicht jede Aussage oder Behauptung unabhängig. Namen werden so angezeigt, wie sie öffentlich auf Change.org veröffentlicht oder von den Autoren eingereicht wurden.',

  // ── ShortStatements ──
  'fans.shortStatements.label': 'KURZE AUSSAGEN',
  'fans.shortStatements.ariaPrev': 'Vorherige Aussagen',
  'fans.shortStatements.ariaNext': 'Nächste Aussagen',

  // ── SubmitTestimonial ──
  'fans.submit.title': 'TEILE DIE WIRKUNG',
  'fans.submit.body': 'Unterstützer können ihre eigenen Berichte darüber einreichen, wie der Inhalt, die Unternehmen, die Lehren oder die Rechtserfahrung von Andrew oder Tristan Tate ihr Leben und ihre Perspektiven beeinflusst haben.',
  'fans.submit.btn': 'ERFAHRUNGSBERICHT EINREICHEN',
  'fans.submit.successTitle': 'Vielen Dank',
  'fans.submit.successBody': 'Dein Erfahrungsbericht ist eingegangen. Er wird vor der Veröffentlichung geprüft.',
  'fans.submit.labelName': 'Angezeigter Name oder Initialen *',
  'fans.submit.placeholderName': 'z. B. Max M.',
  'fans.submit.labelTestimonial': 'Dein Erfahrungsbericht *',
  'fans.submit.placeholderTestimonial': 'Schildere deine Erfahrung...',
  'fans.submit.labelCountry': 'Land (optional)',
  'fans.submit.placeholderCountry': 'z. B. Deutschland',
  'fans.submit.labelCategory': 'Wirkungskategorie (optional)',
  'fans.submit.selectCategory': 'Kategorie auswählen',
  'fans.submit.categoryOther': 'Andere',
  'fans.submit.checkGenuine': 'Ich bestätige, dass diese Einreichung meine echte persönliche Erfahrung widerspiegelt.',
  'fans.submit.checkPermission': 'Ich autorisiere Tate Protest, diesen Erfahrungsbericht unter dem angegebenen Namen oder den Initialen zu veröffentlichen.',
  'fans.submit.submitBtn': 'BERICHT EINREICHEN',
  'fans.submit.cancel': 'Abbrechen',
  'fans.submit.errorConnection': 'Die Übermittlung war nicht möglich. Bitte prüfe deine Verbindung und versuche es erneut.',

  // ── TestimonialGrid ──
  'fans.grid.empty': 'Keine Erfahrungsberichte für diese Kategorie gefunden.',

  // ── donate/page.tsx ──
  'donate.hero.titleSuccess': 'VIELEN DANK',
  'donate.hero.titleDefault': 'UNTERSTÜTZE DEN KAMPF',
  'donate.hero.subtitleSuccess': 'Deine Unterstützung macht einen Unterschied',
  'donate.hero.subtitleDefault': 'Hilf uns zu organisieren, zu dokumentieren und zu informieren',
  'donate.hero.imgAlt': 'Dunkler kinematografischer abstrakter Hintergrund',

  'donate.success.title': 'VIELEN DANK FÜR DIE UNTERSTÜTZUNG VON TATE PROTEST',
  'donate.success.body': 'Dein Beitrag hilft Tate Protest, seine unabhängige Arbeit zur Förderung von Transparenz, Rechtsstaatlichkeit und gesetzmäßiger friedlicher Interessenvertretung fortzusetzen.',
  'donate.success.shareTateProtest': 'TATE PROTEST TEILEN',
  'donate.success.signPetition': 'PETITION UNTERZEICHNEN',
  'donate.success.returnHome': 'ZUR STARTSEITE',
  'donate.success.shareText': 'Ich habe gerade Tate Protest unterstützt — eine unabhängige Plattform, die Transparenz und Rechtsstaatlichkeit fördert. Mehr erfahren:',

  'donate.form.sectionTitle': 'HILF UNS ZU ORGANISIEREN, ZU DOKUMENTIEREN UND ZU INFORMIEREN',
  'donate.form.sectionBody': 'Dein Beitrag unterstützt die rechtliche Veranstaltungskoordination, Recherche öffentlicher Informationen, Aufklärungsmaterialien, Websitebetrieb und die Technologie, die benötigt wird, um Unterstützer informiert zu halten.',
  'donate.form.noticeBody': 'Jeder Beitrag — groß oder klein — hilft Tate Protest, seine unabhängige Interessenvertretung für Transparenz, Rechtsstaatlichkeit und faire Gerichtsverfahren fortzusetzen.',

  'donate.method.choose': 'Wähle eine Beitragsmethode',
  'donate.method.cardTitle': 'Karte',
  'donate.method.cardDescription': 'Einmaliger oder monatlicher Beitrag über Stripe.',
  'donate.method.cryptoTitle': 'USDT auf Solana',
  'donate.method.cryptoDescription': 'Sende eine direkte Wallet-Überweisung. Keine Wallet-Verbindung erforderlich.',
  'donate.crypto.token': 'Token · USDT',
  'donate.crypto.network': 'Netzwerk · Solana',
  'donate.crypto.title': 'USDT direkt senden',
  'donate.crypto.intro': 'Nutze deine Wallet oder die Auszahlungsfunktion deiner Börse, um USDT an die unten angegebene Adresse zu senden.',
  'donate.crypto.recipientLabel': 'Empfänger-Wallet-Adresse',
  'donate.crypto.viewExplorer': 'Auf Solscan ansehen',
  'donate.crypto.addressAccessibleLabel': 'Vollständige USDT-Empfängeradresse auf Solana',
  'donate.crypto.copyAddress': 'Adresse kopieren',
  'donate.crypto.copySuccess': 'Adresse kopiert. Prüfe Token, Netzwerk und vollständige Adresse in deiner Wallet, bevor du sendest.',
  'donate.crypto.copyError': 'Automatisches Kopieren nicht möglich. Wähle die vollständige Adresse oben aus und kopiere sie manuell.',
  'donate.crypto.manualCopy': 'Kopieren nicht möglich? Wähle die vollständige Adresse oben aus und kopiere sie manuell.',
  'donate.crypto.stepsTitle': 'Überweisungsschritte',
  'donate.crypto.step1': 'Öffne deine Wallet oder Börse und wähle USDT senden oder auszahlen.',
  'donate.crypto.step2': 'Wähle das Solana-Netzwerk und füge die Empfängeradresse oben ein.',
  'donate.crypto.step3': 'Prüfe USDT, Solana und die vollständige Empfängeradresse, bevor du die Überweisung bestätigst.',
  'donate.crypto.networkWarning': 'Sende AUSSCHLIESSLICH USDT über Solana. Verwende nicht Ethereum, TRON oder ein anderes Netzwerk.',
  'donate.crypto.irreversible': 'Überweisungen sind unwiderruflich. Deine Wallet benötigt möglicherweise SOL für Solana-Netzwerkgebühren.',
  'donate.crypto.directTransfer': 'Dies ist eine direkte Wallet-Überweisung. Die Website bestätigt den Eingang nicht automatisch und stellt keine Quittung aus.',

  'donate.priority.label': 'AKTUELLE PRIORITÄT',
  'donate.priority.title': 'NÄCHSTER GERICHTSTERMIN: UNBEKANNT',
  'donate.priority.body': 'Unterstütze die laufende Recherche öffentlicher Informationen, Kommunikation, Öffentlichkeitsarbeit und Fallaktualisierungen, solange kein neuer Gerichtstermin bekannt gegeben wurde.',

  'donate.largeContrib.title': 'PLANST DU EINEN GRÖSSEREN BEITRAG?',
  'donate.largeContrib.body': 'Für Beiträge von $2.500 oder mehr kontaktiere Tate Protest, um die Identitätsverifizierung abzuschließen und genehmigte Zahlungsvereinbarungen zu besprechen.',
  'donate.largeContrib.btn': 'BEITRAGS-TEAM KONTAKTIEREN',
  'donate.largeContrib.warning': 'Sende niemals Bank- oder Finanzinformationen über eine nicht verifizierte E-Mail, ein Social-Media-Konto oder eine Direktnachricht.',

  'donate.sidebar.howUsedTitle': 'Wie Beiträge verwendet werden können',
  'donate.sidebar.howUsedFootnote': 'Diese Beispiele veranschaulichen mögliche Verwendungen von Beiträgen. Die tatsächlichen Ausgaben hängen von den aktuellen betrieblichen und Kampagnenbedürfnissen ab.',

  'donate.sidebar.howUsed.25.title': 'Aufklärungsmaterialien',
  'donate.sidebar.howUsed.25.desc': 'Unterstützt gedruckte und digitale Materialien zur öffentlichen Information.',
  'donate.sidebar.howUsed.50.title': 'Demonstrationsbedarf',
  'donate.sidebar.howUsed.50.desc': 'Hilft bei der Bereitstellung von Schildern, Bannern, Wasser, Identifikationsmaterialien und Bedarf für friedliche Veranstaltungen.',
  'donate.sidebar.howUsed.100.title': 'Recherche und Kommunikation',
  'donate.sidebar.howUsed.100.desc': 'Unterstützt Recherchen öffentlicher Aufzeichnungen, Falldokumentation, Websitebetrieb und Kommunikation mit Unterstützern.',
  'donate.sidebar.howUsed.500.title': 'Veranstaltungskoordination',
  'donate.sidebar.howUsed.500.desc': 'Trägt zur rechtlichen Veranstaltungslogistik, Ausstattung, ggf. erforderlichen Genehmigungen und koordinierter öffentlicher Aufklärung bei.',

  'donate.sidebar.secureTitle': 'Sichere Zahlungsabwicklung',
  'donate.sidebar.secure1': 'Zahlungen werden sicher über Stripe abgewickelt',
  'donate.sidebar.secure2': 'Tate Protest empfängt oder speichert keine vollständigen Karteninformationen direkt',
  'donate.sidebar.secure3': 'Standard-Zahlungsbearbeitungsgebühren können von Beiträgen abgezogen werden',

  'donate.sidebar.transparencyTitle': 'Transparenz der Beiträge',
  'donate.sidebar.recipient.label': 'Empfänger: Tate Protest',
  'donate.sidebar.useOfFunds.label': 'Verwendung der Mittel',
  'donate.sidebar.useOfFunds.value': 'Die Beiträge unterstützen die unabhängige Interessenvertretung von Tate Protest, Kommunikation, Recherche, Websitebetrieb, Aufklärung und rechtliche Veranstaltungskoordination.',
  'donate.sidebar.affiliation.label': 'Zugehörigkeit',
  'donate.sidebar.affiliation.value': 'Beiträge werden nicht an Andrew Tate, Tristan Tate, ihre Familien, Anwälte oder die Rechtsverteidigung gezahlt, es sei denn, dies wird ausdrücklich und öffentlich bekannt gegeben.',
  'donate.sidebar.processing.label': 'Abwicklung',
  'donate.sidebar.processing.value': 'Zahlungen werden von Stripe abgewickelt und können den Standard-Verarbeitungsgebühren unterliegen.',

  'donate.sidebar.questions': 'Hast du Fragen zum Beitragen?',
  'donate.sidebar.contactUs': 'Kontaktiere uns',
  'donate.sidebar.questionsEnd': 'und wir antworten dir innerhalb von 24 Stunden.',

  'donate.transparency.title': 'TRANSPARENZ IN AKTION',
  'donate.transparency.body': 'Tate Protest ist bestrebt, Unterstützern zu zeigen, wie Beiträge dazu beitragen, friedliche Interessenvertretung, öffentliche Recherche, Aufklärung und Veranstaltungskoordination voranzutreiben.',
  'donate.transparency.campaignGoal': 'KAMPAGNENZIEL',
  'donate.transparency.amountRaised': 'GESAMMELTER BETRAG',
  'donate.transparency.eventExpenses': 'VERANSTALTUNGSKOSTEN',
  'donate.transparency.completedInitiatives': 'ABGESCHLOSSENE INITIATIVEN',
  'donate.transparency.photosResults': 'FOTOS / ERGEBNISSE',
  'donate.transparency.pending': 'Kampagnenberichte werden veröffentlicht, sobald verifizierte Zahlen vorliegen.',

  // ── DonationForm ──
  'donate.donationForm.terminal': 'sicheres Spendenportal',
  'donate.donationForm.cancelledMsg': 'Dein Beitrag wurde nicht abgeschlossen. Falls du auf Probleme gestoßen bist, versuche es erneut oder',
  'donate.donationForm.cancelledContact': 'kontaktiere uns',
  'donate.donationForm.oneTime': 'Einmalig',
  'donate.donationForm.monthly': 'Monatlich',
  'donate.donationForm.monthlyNote': 'Monatlich wiederkehrender Beitrag — jederzeit kündbar',
  'donate.donationForm.selectAmount': '> beitragsbetrag_auswählen',
  'donate.donationForm.other': '> ANDERER BETRAG',
  'donate.donationForm.enterAmount': 'Betrag eingeben',
  'donate.donationForm.nameLabel': '> name',
  'donate.donationForm.nameOptional': '// optional',
  'donate.donationForm.namePlaceholder': 'Dein Name',
  'donate.donationForm.emailLabel': '> e-mail',
  'donate.donationForm.emailOptional': '// optional',
  'donate.donationForm.emailPlaceholder': 'du@beispiel.de',
  'donate.donationForm.messageLabel': '> unterstützungsnachricht',
  'donate.donationForm.messageOptional': '// optional',
  'donate.donationForm.messagePlaceholder': 'Warum liegt dir diese Sache am Herzen...',
  'donate.donationForm.redirecting': 'weiterleitung_zur_zahlung...',
  'donate.donationForm.contributeBtn': '> {{amount}} SICHER BEITRAGEN',
  'donate.donationForm.securityNote': '// sichere zahlungsabwicklung // bereitgestellt von stripe',
  'donate.donationForm.errorDefault': 'Etwas ist schiefgelaufen. Bitte versuche es erneut.',
};
